import { Node } from 'tiptap'
import { wrappingInputRule, setBlockType, toggleWrap } from 'tiptap-commands'


export default class Codeline extends Node {

	get name() {
		return 'codeline'
	}


	get schema() {
		return {
			content: 'inline*',
			group: 'block',
			draggable: false,
			parseDOM: [
				// {
				// 	tag: 'body',
				// 	preserveWhitespace : true,
				// },
				{
					tag: 'div',
					preserveWhitespace : true,
				},
				{
					tag: 'h1',
					preserveWhitespace : true,
				},
				{
					tag: 'h2',
					preserveWhitespace : true,
				},
				{
					tag: 'h3',
					preserveWhitespace : true,
				},
				{
					tag: 'h4',
					preserveWhitespace : true,
				},
				{
					tag: 'p',
					preserveWhitespace : true,
				},
				{
					tag: 'pre',
					preserveWhitespace : "full",
				},
				{
					tag: 'tr',
					preserveWhitespace : true,
				},
			],
			toDOM: () => ['div', {class:'codeline'}, 0],
		}
	}

	commands({ type }) {
		return () => setBlockType(type)
	}
}